import React, { Component } from 'react';
import './styles.scss';
import { getImage, api } from '../utils';
import PasswordExpiryPopUp from '../PasswordExpiry/PasswordExpiryPopUp';
import { RandomizedUserBadgeColors, ModalBodyIdentifiers, Roles } from '../constants';
// import PasswordExpiryPopUp from '../PasswordExpiry/PasswordExpiryPopUp';
import Modal from '../CommonComponents/Modal';
import AddTenantModal from '../Components/AddTenantModal/AddTenantModal';
import ExistingAdminsList from '../Components/ExistingAdminsList/ExistingAdminsList';
import CreateTenantModal from '../Components/MultiTenant/CreateTenantModal';
import { TenantDisplay } from '../DumpComponents/TenantDisplay/index';
import Button from '../CommonComponents/Button';
// @ts-ignore
import addBlue from '../assets/icons/add-blue.svg';
import Toaster from '../DumpComponents/Toaster/Toast';
type Props = {
  setStatus: Function;
  toasterVal: string;
  countforToaster: number;
  setLogoutLoading: Function;
  clearSessionInterval: Function;
  tenants: any;
  changeScreen: Function;
  showScreen: string;
  role: string;
  tenantId: number;
  selectedTenantName: string;
  tenantImageURL: string;
  getTenant: Function;
  renderTenantMutationModal: Function;
  closeTenantMutatationModal: Function;
  setTenantAdminErrorMessage: Function;
  showTenantAdminModal: Function;
  tenantMutatation: any;
  getAllusers: Function;
  clearPreviousSession: Function;
};
type State = {
  buttonTitle: {
    addAdmin: string;
    confirmAdmin: string;
    removeAdmin: string;
  };
  tenantAdminProcessing: boolean;
  tenants: any;
  isPopupOpen: boolean;
  shwToaster: boolean;
  islogoutLoading: boolean;
  passwordExpiry: boolean;
  passwordExpireOn: string;
  // tenantMutatation: {
  //   isVisible: boolean;
  //   modalBodyIdentifier: number;
  //   tenantAdminErrorMessage?: string;
  //   tenantInfo: {
  //     disabled: boolean;
  //     tenantName: string;
  //     imageURL: string;
  //     tenantId: number;
  //     tenantAdmins?: any;
  //   };
  // };
  toasterConfig: {
    isVisible: boolean;
    toasterMessage: string;
  };
  showLogoutModal: boolean;
  showSwitchModal: boolean;
};

export default class Topbar extends Component<Props, State> {
  name = sessionStorage.getItem('userName') || '';
  mailId = sessionStorage.getItem('userEmail') || '';
  notify = sessionStorage.getItem('notify');
  passwordExpireOn = sessionStorage.getItem('passwordExpireOn');
  // mailId = sessionStorage.getItem('userId') || '';
  private myRef: React.RefObject<HTMLInputElement>;
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.myRef = React.createRef();
    this.switchTenantApi = this.switchTenantApi.bind(this);
  }

  setInitialState(): State {
    return {
      buttonTitle: {
        addAdmin: 'Add',
        confirmAdmin: 'Confirm',
        removeAdmin: 'Remove',
      },
      tenantAdminProcessing: false,
      tenants: [],
      isPopupOpen: false,
      shwToaster: false,
      islogoutLoading: false,
      passwordExpiry: false,
      passwordExpireOn: '',
      // tenantMutatation: {
      //   isVisible: false,
      //   modalBodyIdentifier: 1,
      //   tenantAdminErrorMessage: '',
      //   tenantInfo: {
      //     disabled: false,
      //     tenantName: '',
      //     imageURL: '',
      //     tenantId: 0,
      //     tenantAdmins: [],
      //   },
      // },
      toasterConfig: {
        isVisible: false,
        toasterMessage: '',
      },
      showLogoutModal: false,
      showSwitchModal: false,
    };
  }
  handleClickOutside = (event: any) => {
    if (this.myRef.current && !this.myRef.current.contains(event.target)) {
      this.setState({
        isPopupOpen: false,
      });
    }
  };
  togglePopup() {
    this.setState((prevState) => ({
      isPopupOpen: !prevState.isPopupOpen,
    }));
  }

  logout() {
    sessionStorage.removeItem('agentLogin');
    this.props.setLogoutLoading(true);

    api('Logout').finally(() => {
      // api('clearSessionForAgent', 'POST', {
      //   user: 'agent',
      //   sessionID: sessionStorage.getItem('agentActiveSession'),
      //   agentId: sessionStorage.getItem('agentId'),
      // }).finally(() => {
      this.props.clearPreviousSession();
      document.dispatchEvent(new CustomEvent('socketClose'));
      this.props.setLogoutLoading(false);
      this.props.setStatus(false);
      this.props.changeScreen('');
      sessionStorage.removeItem('roleId');
      sessionStorage.removeItem('wsConnendpoint');
      sessionStorage.removeItem('websocketendpoint');
      sessionStorage.removeItem('autoassignOnLoginCalled');
      sessionStorage.removeItem('iswsagentIntervion');
      sessionStorage.removeItem('iswebsocketendpoint');
      sessionStorage.removeItem('iswsConnendpoint');
      sessionStorage.removeItem('agentActiveSession');
      sessionStorage.removeItem('ischatActive');
      this.props.clearSessionInterval();
    });
  }
  componentDidUpdate(prevProps: Props, _: State) {
    if (this.props.countforToaster !== prevProps.countforToaster) {
      this.setState({
        shwToaster: true,
      });
      setTimeout(() => {
        this.setState({
          shwToaster: false,
        });
      }, 3000);
    }
  }
  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
    // console.log(this.notify);
    if (this.notify === 'true') {
      this.setState({
        passwordExpiry: true,
        passwordExpireOn: this.passwordExpireOn || '',
      });
    }
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
  closePasswordExpiryPop = (e: Event) => {
    e.stopPropagation();
    this.setState({
      passwordExpiry: false,
    });
    sessionStorage.setItem('notify', 'false');
  };

  addTenantAdmin = (reqObj: any) => {
    this.setState({
      buttonTitle: {
        ...this.state.buttonTitle,
        addAdmin: 'Adding...',
      },
      tenantAdminProcessing: true,
    });
    api(`addTenantAdmin`, 'POST', reqObj)
      .then((response) => {
        this.setState(
          {
            buttonTitle: {
              ...this.state.buttonTitle,
              addAdmin: 'Add',
            },
            tenantAdminProcessing: false,
          },
          () => {
            if (response.status === 'Success') {
              this.props.closeTenantMutatationModal();
              this.renderToaster('New tenant admin added');
            } else {
              this.setState({
                buttonTitle: {
                  ...this.state.buttonTitle,
                  addAdmin: 'Add',
                },
                tenantAdminProcessing: false,
              });
              this.props.setTenantAdminErrorMessage(
                '' +
                  reqObj.firstName +
                  ' ' +
                  reqObj.firstName +
                  ' (' +
                  reqObj.userEmail +
                  ') is already added to one or more bot teams with other roles. Please remove the user from all other roles to add them as a tenant admin.'
              );
            }
          }
        );
      })
      .catch((e) => {
        this.setState({
          buttonTitle: {
            ...this.state.buttonTitle,
            addAdmin: 'Add',
          },
          tenantAdminProcessing: false,
        });
        this.props.setTenantAdminErrorMessage('error');
        console.log(e);
      });
  };
  fetchAllTenants = (toasterMessage?: string) => {
    //  api('getAllTenant').then((data: any) => {
    api('getTenant', 'POST', {
      agentSessionID: sessionStorage.getItem('agentActiveSession'),
      agentId: sessionStorage.getItem('agentId'),
    }).then((data: any) => {
      this.setState({ tenants: data });
    });
    if (toasterMessage) {
      // this.renderToaster(toasterMessage);
    }
  };

  updateTenantInfo = () => {
    // this.fetchAllTenants();
    this.props.getAllusers(this.props.tenantId);
  };

  renderToaster = (toasterMessage: any) => {
    this.setState(
      {
        toasterConfig: {
          isVisible: true,
          toasterMessage,
        },
      },
      () => {
        setTimeout(() => {
          this.setState({
            toasterConfig: {
              isVisible: false,
              toasterMessage: '',
            },
          });
        }, 3000);
      }
    );
  };

  tenantProfileUpdation = () => {
    this.props.getTenant(); //needs to check now
    this.renderToaster('Tenant Updated');
    this.props.closeTenantMutatationModal();
  };

  switchTenantApi() {
    api('switchTenant', 'POST', {
      agentSessionID: sessionStorage.getItem('agentActiveSession'),
      tenantId: this.props.tenantId,
    }).finally(() => {
      document.dispatchEvent(new CustomEvent('socketClose'));
      sessionStorage.removeItem('wsConnendpoint');
      sessionStorage.removeItem('websocketendpoint');
      sessionStorage.removeItem('iswsagentIntervion');
      sessionStorage.removeItem('iswebsocketendpoint');
      sessionStorage.removeItem('iswsConnendpoint');
      sessionStorage.removeItem('ischatActive');
      setTimeout(() => {
        this.props.changeScreen('TenantSelection');
      }, 500);
      this.setState({
        isPopupOpen: false,
      });
    });
  }
  render() {
    return (
      <div className='topbar-container'>
        <div className='logo'>
          <img src={getImage(`senseforth-logo.svg`)} alt='senseforth.ai' />
        </div>
        {this.state.shwToaster ? (
          <div className='toaster-wrapper'>
            <div className='timezone-toaster'>{this.props.toasterVal}</div>
          </div>
        ) : (
          <div className='title'>HYBRID CHAT</div>
        )}
        <div
          className='user'
          onClick={() => {
            this.togglePopup();
          }}
          ref={this.myRef}
          // title={`${this.name}\n${this.mailId}`}
          // title={`${this.name}${'\n'}${this.mailId}${
          title={`${this.name}\n${this.mailId}${
            this.props.selectedTenantName && this.props.role !== Roles.TENANTADMIN.value
              ? `\nTenant : ${this.props.selectedTenantName} `
              : ''
          }`}>
          <div className='ui-box-left'>
            <div className='ui-box-name'>{this.name}</div>
            {this.props.tenantId && this.props.showScreen !== 'TenantSelection' ? (
              <div className='ui-box-tenant'>{this.props.selectedTenantName}</div>
            ) : null}
          </div>
          {this.props.tenantId && this.props.showScreen !== 'TenantSelection' ? (
            <div style={{ position: 'relative', marginRight: '8px' }}>
              <TenantDisplay
                tenantName={this.props.selectedTenantName}
                tenantImageURL={this.props.tenantImageURL}
                renderType='type-3'
              />
            </div>
          ) : (
            <div
              className='user-badge'
              style={{
                backgroundColor:
                  RandomizedUserBadgeColors[
                    (this.name[0] || '').toLowerCase().charCodeAt(0) % 97
                  ],
              }}>
              {this.name[0]}
            </div>
          )}
          {this.state.isPopupOpen && (
            <div className='logout-popup' onClick={(e) => e.stopPropagation()}>
              <div className='option-wrapper'>
                {this.props.role === Roles.TENANTADMIN.value &&
                this.props.showScreen !== 'TenantSelection' ? (
                  <>
                    <div
                      className='each-option hoverable'
                      onClick={() => {
                        // props.setShowLogoutPopup(false);

                        this.props.renderTenantMutationModal(
                          this.props.tenantMutatation.tenantInfo.tenantName,
                          this.props.tenantMutatation.tenantInfo.imageURL,
                          this.props.tenantMutatation.tenantInfo.tenantId,
                          ModalBodyIdentifiers.TenantProfile
                        );
                      }}>
                      Tenant profile
                    </div>
                    <div
                      className='each-option hoverable'
                      onClick={() => {
                        this.props.showTenantAdminModal();
                      }}>
                      Tenant admins
                    </div>
                  </>
                ) : null}
                {/* NEEDS TO BE CHANGES, DOESN'T WORK ON PAGE REFRESH */}
                {this.props.showScreen === 'TenantSelection' ||
                this.props.tenants.length <= 1 ? null : ( //  || this.props.tenants.length <= 1
                  <div
                    className='each-option hoverable'
                    onClick={() => {
                      if (sessionStorage.getItem('ischatActive') === 'collected') {
                        this.setState({
                          showSwitchModal: true,
                        });
                      } else {
                        this.switchTenantApi();
                      }
                    }}>
                    Switch tenants
                  </div>
                )}
                <div
                  className='user-popup-logout hoverable'
                  onClick={() => {
                    if (sessionStorage.getItem('ischatActive') === 'collected') {
                      this.setState({
                        showLogoutModal: true,
                      });
                    } else {
                      this.logout();
                    }
                  }}>
                  <div>Logout</div>
                  <div className='up-email' title={this.mailId}>
                    {this.mailId}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {this.state.passwordExpiry ? (
          <PasswordExpiryPopUp
            msg={this.state.passwordExpireOn}
            onClickClose={this.closePasswordExpiryPop}
          />
        ) : (
          ''
        )}
        <Modal
          isOpen={this.props.tenantMutatation.isVisible}
          title='Tenant admins'
          onClose={this.props.closeTenantMutatationModal}
          innerStyle={{
            paddingRight: 0,
            paddingBottom: 0,
          }}>
          {this.props.tenantMutatation.modalBodyIdentifier ===
          ModalBodyIdentifiers.TenantAdmins ? (
            <div className='ts-existing-admin-w'>
              <ExistingAdminsList
                updateTenantInfo={() => this.updateTenantInfo()}
                usersDetails={this.props.tenantMutatation.tenantInfo.tenantAdmins}
                tenantId={this.props.tenantMutatation.tenantInfo.tenantId}
                buttonTitle={this.state.buttonTitle}
              />
              <div className='add-tenant-button'>
                <img src={addBlue} alt='add Tenant admin' />
                <Button
                  text='Add tenant admin'
                  theme='secondary-blue-without-border'
                  onClick={() =>
                    this.props.renderTenantMutationModal(
                      this.props.tenantMutatation.tenantInfo.tenantName,
                      this.props.tenantMutatation.tenantInfo.imageURL,
                      this.props.tenantMutatation.tenantInfo.tenantId,
                      ModalBodyIdentifiers.AddTenantAdmin
                    )
                  }
                />
              </div>
              <div className='done-button'>
                <Button
                  text='Done'
                  theme='dark'
                  onClick={this.props.closeTenantMutatationModal}
                />
              </div>
            </div>
          ) : null}
        </Modal>
        {this.props.tenantMutatation.modalBodyIdentifier ===
        ModalBodyIdentifiers.AddTenantAdmin ? (
          <AddTenantModal
            clientName={this.props.tenantMutatation.tenantInfo.tenantName}
            imageUrl={this.props.tenantMutatation.tenantInfo.imageURL}
            tenantId={this.props.tenantMutatation.tenantInfo.tenantId}
            closeModal={() => {
              this.props.setTenantAdminErrorMessage('');
              this.props.closeTenantMutatationModal();
            }}
            submitForm={this.addTenantAdmin}
            existingAdminEmailList={this.props.tenantMutatation.tenantInfo.tenantAdmins.map(
              (ta: any) => ta.userEmail
            )}
            tenantAdminErrorMessage={this.props.tenantMutatation.tenantAdminErrorMessage}
            onResetErrorMessage={() => this.props.setTenantAdminErrorMessage('')}
            buttonTitle={this.state.buttonTitle}
            tenantAdminProcessing={this.state.tenantAdminProcessing}
          />
        ) : null}
        {this.props.tenantMutatation.isVisible &&
        this.props.tenantMutatation.modalBodyIdentifier ===
          ModalBodyIdentifiers.TenantProfile ? (
          <CreateTenantModal
            isUpdatingProfile={true}
            onClose={this.props.closeTenantMutatationModal}
            onCreate={this.tenantProfileUpdation}
            tenantInfo={this.props.tenantMutatation.tenantInfo}
            existingTenantNames={this.props.tenants.map((_: any) => _.tenantName)}
          />
        ) : null}
        {this.state.toasterConfig.isVisible ? (
          <Toaster
            deleteTime={3000}
            position='top-center'
            toastList={{
              backgroundColor: '#000',
              description: this.state.toasterConfig.toasterMessage,
            }}
          />
        ) : null}

        <Modal
          isOpen={this.state.showLogoutModal}
          title='Confirm logout'
          showBorders='true'
          onClose={() => {
            this.setState({
              showLogoutModal: false,
            });
          }}>
          <div className='logout-modal-wrapper'>
            <span>
              When you logout, active chats under your <i>Mychats</i> tab will be released
              back to respective queues.
            </span>
            <div style={{ display: 'flex', justifyContent: 'end', marginTop: '24px' }}>
              <Button
                text='Cancel'
                theme='secondary-blue'
                onClick={() => {
                  this.setState({
                    showLogoutModal: false,
                  });
                }}
              />
              <Button
                text='Logout'
                theme='dark-blue'
                onClick={() => {
                  this.setState(
                    {
                      showLogoutModal: false,
                    },
                    () => {
                      this.logout();
                    }
                  );
                }}
              />
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.showSwitchModal}
          title='Switch to a different tenant?'
          showBorders='true'
          onClose={() => {
            this.setState({
              showSwitchModal: false,
            });
          }}>
          <div className='logout-modal-wrapper'>
            <span className='modal-message'>
              When you exit this tenant, active chats under your <i>Mychats</i> tab in
              this tenant will be released back to respective queues.
            </span>
            <div style={{ display: 'flex', justifyContent: 'end', marginTop: '24px' }}>
              <Button
                text='Cancel'
                theme='secondary-blue'
                onClick={() => {
                  this.setState({
                    showSwitchModal: false,
                  });
                }}
              />
              <Button
                text='Switch'
                theme='dark-blue'
                onClick={() => {
                  this.setState(
                    {
                      showSwitchModal: false,
                    },
                    () => {
                      this.switchTenantApi();
                    }
                  );
                }}
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
